(() => {
  const triggerSelector = '[data-krema-whatsapp-checkout]';

  async function clearCart() {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to clear cart');
    }

    if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      await window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'krema-whatsapp' });
    }
  }

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;

    event.preventDefault();

    const whatsappUrl = trigger.getAttribute('href');
    if (!whatsappUrl) return;
    let whatsappWindow = window.open(whatsappUrl, '_blank');
    if (!whatsappWindow) {
      const fallbackLink = document.createElement('a');
      fallbackLink.href = whatsappUrl;
      fallbackLink.target = '_blank';
      fallbackLink.rel = 'noopener noreferrer';
      fallbackLink.click();
    } else {
      whatsappWindow.opener = null;
    }

    try {
      await clearCart();
    } catch (error) {
      console.error(error);
    }
  });
})();
